export const getDefaultValues = (UploadToServerDetails) => ({
  UploadToServerPathDisk: UploadToServerDetails?.UploadToServerPathDisk || '',
  UploadToServerPathHTTP: UploadToServerDetails?.UploadToServerPathHTTP || '',
  UploadToServerTitle: UploadToServerDetails?.UploadToServerTitle || '',
  UploadToServerDescription: UploadToServerDetails?.UploadToServerDescription || '',
  UploadToServerServerDestinationURL: UploadToServerDetails?.UploadToServerServerDestinationURL || '',
  // ----------------------------------------------
  UploadedFileName: UploadToServerDetails?.UploadedFileName || '',
  UploadedFileNameWithLink: UploadToServerDetails?.UploadToServerPathDisk === '/' ? UploadToServerDetails?.UploadToServerPathHTTP : '',
  UploadedFileNameWithHardDisk: UploadToServerDetails?.UploadToServerPathDisk !== '/' ? UploadToServerDetails?.UploadToServerPathHTTP : '',
});
